import React from "react";
import { View, StyleSheet, ScrollView } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import { AssignmentSuggestionCard, AssignmentSuggestion } from "../AssignmentSuggestionCard/AssignmentSuggestionCard";
import { spacing, colors, typographyScale } from "../../../../styles/design-system";

export interface AssignmentGroup {
  courseName: string;
  courseCode?: string | null;
  assignments: AssignmentSuggestion[];
}

interface AssignmentSuggestionCardListProps {
  title: string;
  groups: AssignmentGroup[];
  onAssignmentPress: (assignment: AssignmentSuggestion) => void;
  showCourseHeaders?: boolean;
}

export const AssignmentSuggestionCardList: React.FC<AssignmentSuggestionCardListProps> = ({
  title,
  groups,
  onAssignmentPress,
  showCourseHeaders = true,
}) => {
  if (groups.length === 0) {
    return null;
  }

  return (
    <View style={styles.container}>
      <CustomText text={title} useTranslationText={false} style={styles.title} />
      <ScrollView style={styles.scrollView} contentContainerStyle={styles.scrollContent}>
        <View style={styles.groupsContainer}>
          {groups.map((group, groupIndex) => (
            <View key={groupIndex} style={styles.courseSection}>
              {showCourseHeaders && (
                <CustomText
                  text={group.courseCode ? `${group.courseName} (${group.courseCode})` : group.courseName}
                  useTranslationText={false}
                  style={styles.courseName}
                />
              )}
              <View style={styles.cardsContainer}>
                {group.assignments.map((assignment) => (
                  <AssignmentSuggestionCard key={assignment.id} assignment={assignment} onPress={onAssignmentPress} />
                ))}
              </View>
            </View>
          ))}
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: "100%",
    marginTop: spacing.xl,
    maxHeight: 400,
    paddingHorizontal: spacing.sm,
  },
  title: {
    fontSize: typographyScale.textBase.fontSize,
    fontWeight: "600",
    color: colors.grey[900],
    marginBottom: spacing.sm,
  },
  scrollView: {
    flexGrow: 0,
    flexShrink: 1,
  },
  scrollContent: {
    paddingBottom: spacing.xs,
  },
  groupsContainer: {
    gap: spacing.md,
  },
  courseSection: {
    marginBottom: 12,
  },
  cardsContainer: {
    gap: spacing.xs,
  },
  courseName: {
    fontSize: typographyScale.textXs.fontSize,
    fontWeight: "600",
    color: colors.grey[500],
    textTransform: "uppercase",
    letterSpacing: 0.5,
    marginBottom: spacing.xs,
    paddingHorizontal: spacing.xxs,
  },
});
